import { svg } from 'lit';
export const arrowDown16Svg = svg `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 4V12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 8L8 12L4 8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`;
//# sourceMappingURL=arrow-down_16.svg.js.map